// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__eFMkN","radio__inputs":"style_radio__inputs__FYTcm","serial__number_input":"style_serial__number_input__2vF5M"};